import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import AssessmentIcon from '@mui/icons-material/Assessment';
import InventoryIcon from '@mui/icons-material/Inventory';
import PeopleIcon from '@mui/icons-material/People';
import PaymentIcon from '@mui/icons-material/Payment';
import PersonIcon from '@mui/icons-material/Person';

export const reportTypes = [
  {
    id: 'daily-sales',
    name: 'Daily Operations Report',
    description: 'Complete business operations overview for a specific day',
    icon: TrendingUpIcon,
    color: '#1976d2'
  },
  {
    id: 'monthly-sales',
    name: 'Monthly Sales Report',
    description: 'Comprehensive sales analysis for a month',
    icon: AssessmentIcon,
    color: '#388e3c'
  },
  {
    id: 'inventory',
    name: 'Inventory Report',
    description: 'Current inventory status and low stock alerts',
    icon: InventoryIcon,
    color: '#f57c00'
  },
  {
    id: 'customers',
    name: 'Customer Report',
    description: 'New customers and customer activity',
    icon: PeopleIcon,
    color: '#7b1fa2'
  },
  {
    id: 'individual-customer',
    name: 'Individual Customer Report',
    description: 'Detailed activity report for a specific customer',
    icon: PersonIcon,
    color: '#d32f2f'
  },
  {
    id: 'payment-methods',
    name: 'Payment Methods Report',
    description: 'Payment method usage analysis',
    icon: PaymentIcon,
    color: '#c2185b'
  }
];
